import { toast } from "sonner";
import { api, CONTACT_KIND, errorText } from "@/lib/api";

const KIND_FOR = { collection: "customer", credit_sale: "customer", income: "customer", supplier_payment: "supplier", credit_purchase: "supplier", advance: "employee" };

export async function promptNewContact(txKind, onAdded) {
  const kind = KIND_FOR[txKind] || "customer";
  const name = window.prompt(`Yeni cari adı (${CONTACT_KIND[kind]}):`);
  if (!name || !name.trim()) return "";
  try {
    const r = await api.post("/contacts", { name: name.trim(), kind });
    await onAdded?.();
    toast.success(`${name.trim()} cari olarak eklendi`);
    return r.data.id;
  } catch (e) { toast.error(errorText(e)); return ""; }
}

export const ContactSelect = ({ contacts, value, onPick, txKind, onAdded, testId, ...rest }) => (
  <select value={value} onChange={async e => { const v = e.target.value; onPick(v === "__new__" ? await promptNewContact(txKind, onAdded) : v); }} data-testid={testId} {...rest}>
    <option value="">—</option>
    {contacts.map(x => <option key={x.id} value={x.id}>{x.name}{x.kind ? ` (${CONTACT_KIND[x.kind] || x.kind})` : ""}</option>)}
    <option value="__new__">+ Yeni cari ekle…</option>
  </select>
);
